const GetUsers = 'UserManagement/GetUsers'
const GetAllUsers = 'UserManagement/GetAllUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const CreateUser = 'UserCollectionMapping/CreateUser'
const UpdateUser = 'UserCollectionMapping/UpdateUser'
const RoleCreateUser = 'User/CreateUser'
const RoleUpdateUser = 'User/UpdateUser'
const GetAllRoles = "UserManagement/GetAllRoles"
const GetCategories = "Common/GetCategories"
const GetCategorieTypesDescription = "Common/UpdateCategoriesAndTypes"
const GetIPAddress = 'Common/GetIPAddress'

export const ApiUrls = {
  GetUsers,
  GetAllUsers,
  GetUserRoles,
  SaveUserRoles,
  CreateUser,
  UpdateUser,
  RoleCreateUser,
  RoleUpdateUser,
  GetAllRoles,
  GetCategories,
  GetCategorieTypesDescription,
  GetIPAddress
}
